import { UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { Result_Map, Result_Bind, FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { some, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { record_type, bool_type, obj_type, unit_type, list_type, array_type, string_type, option_type, equals } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { NumberHistoryDTO$reflection, Sim$reflection } from "../Subscriptions/Common.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { getCsrfEnabledRequest, ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders } from "../../HttpV2.js";
import { Http_content, Http_request, Http_method, Http_withCredentials, Http_send } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { BodyContent, HttpMethod } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { NumberState$reflection, BarringStatusDTO1, BarringStatus, BarringStatusDTO1$reflection, DataPackageUsage$reflection, DataPackage$reflection, TopupPackage$reflection, TopupUsage, TopupUsage$reflection, ValidateIcc$reflection, ProviderServicesDTO$reflection } from "./Model.js";
import { string, int64, object, fromString as fromString_1 } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { Auto_generateBoxedEncoder_Z20B7B430, toString } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";

export function Api_loadSim(clientNr, imsi) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Telecom/Sim/byImsi/%i/%i/"))(clientNr)(imsi)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(option_type(Sim$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(option_type(Sim$reflection()), arg_2, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(option_type(Sim$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function Api_loadProviderServices(clientNr, contractNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/provisioning/%i/%i/provider/"))(clientNr)(contractNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(option_type(ProviderServicesDTO$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(option_type(ProviderServicesDTO$reflection()), arg_2, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(option_type(ProviderServicesDTO$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function Api_loadIccNumbers(clientNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Telecom/IccNumbers/%i/"))(clientNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(array_type(string_type), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(array_type(string_type), arg_1, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(array_type(string_type), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function Api_loadValidateIcc(clientNr, icc) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Telecom/ValidateIcc/%i/%s"))(clientNr)(icc)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(ValidateIcc$reflection(), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(ValidateIcc$reflection(), arg_2, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(ValidateIcc$reflection(), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function Api_loadNumberHistory(clientNr, contractNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Telecom/NumberHistory/%i/%i/"))(clientNr)(contractNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(list_type(NumberHistoryDTO$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(NumberHistoryDTO$reflection()), arg_2, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(NumberHistoryDTO$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function TopupApi_loadUsage(clientNr, contractNr, number) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/provisioning/Topup/%i/%i/number/%s/getusage/"))(clientNr)(contractNr)(number)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const caseStrategy_1 = defaultArg(void 0, new CaseStrategy(0));
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(TopupUsage$reflection(), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : ((value_1) => fromString_1((path_1, v) => object((get$) => {
                let objectArg, objectArg_1, objectArg_2;
                return new TopupUsage((objectArg = get$.Optional, objectArg.Field("LimitBytes", uncurry(2, int64))), (objectArg_1 = get$.Optional, objectArg_1.Field("RemainingBytes", uncurry(2, int64))), (objectArg_2 = get$.Required, objectArg_2.Field("StatusDate", string)));
            }, path_1, v), value_1))(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function TopupApi_loadPackages(clientNr, contractNr, number) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/provisioning/Topup/%i/%i/number/%s/getPossibleTopupPackages/"))(clientNr)(contractNr)(number)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_3 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(list_type(TopupPackage$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(TopupPackage$reflection()), arg_3, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(TopupPackage$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function TopupApi_savePackage(clientNr, contractNr, number, topupId) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/provisioning/Topup/%i/%i/number/%s/add/%s/"))(clientNr)(contractNr)(number)(topupId)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const record = some({});
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_4 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(unit_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(unit_type, arg_4, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(obj_type), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(record));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        });
    }
}

export function DataPackageApi_loadCurrent(clientNr, contractNr, number) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/provisioning/datapackage/%i/%i/number/%s/"))(clientNr)(contractNr)(number)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_3 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(option_type(DataPackage$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(option_type(DataPackage$reflection()), arg_3, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(option_type(DataPackage$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function DataPackageApi_loadUsage(clientNr, contractNr, number) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/provisioning/datapackage/%i/%i/number/%s/getusage/"))(clientNr)(contractNr)(number)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_3 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(DataPackageUsage$reflection(), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(DataPackageUsage$reflection(), arg_3, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(DataPackageUsage$reflection(), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function DataPackageApi_loadPossiblePackages(clientNr, contractNr, number) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/provisioning/datapackage/%i/%i/number/%s/getpossibledatapackages/"))(clientNr)(contractNr)(number)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_3 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(list_type(DataPackage$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(DataPackage$reflection()), arg_3, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(DataPackage$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function DataPackageApi_saveSetPackage(clientNr, contractNr, number, datapackageId) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/provisioning/datapackage/%i/%i/number/%s/setdatapackage/%s/"))(clientNr)(contractNr)(number)(datapackageId)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const record = some({});
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_4 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(unit_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(unit_type, arg_4, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(obj_type), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(record));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        });
    }
}

export class MobileApi_Item extends Record {
    constructor(Portation) {
        super();
        this.Portation = Portation;
    }
}

export function MobileApi_Item$reflection() {
    return record_type("Containers.SimpleOrder.Apis.MobileApi.Item", [], MobileApi_Item, () => [["Portation", option_type(bool_type)]]);
}

export class MobileApi_ActivateBody extends Record {
    constructor(AtUtcDate, Item) {
        super();
        this.AtUtcDate = AtUtcDate;
        this.Item = Item;
    }
}

export function MobileApi_ActivateBody$reflection() {
    return record_type("Containers.SimpleOrder.Apis.MobileApi.ActivateBody", [], MobileApi_ActivateBody, () => [["AtUtcDate", string_type], ["Item", MobileApi_Item$reflection()]]);
}

export function MobileApi_saveActivateWithIcc(clientNr, contractNr, number, icc, body) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/provisioning/Mobile/%i/%i/number/%s/activate-with-icc/%s/At"))(clientNr)(contractNr)(number)(icc)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_4 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(unit_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(unit_type, arg_4, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(MobileApi_ActivateBody$reflection()), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(body));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        });
    }
}

export function MobileApi_saveDeactivate(clientNr, contractNr, number, body) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/provisioning/Mobile/%i/%i/number/%s/deactivate/At"))(clientNr)(contractNr)(number)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_3 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(unit_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(unit_type, arg_3, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(MobileApi_ActivateBody$reflection()), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(body));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        });
    }
}

export function MobileApi_saveChangeIcc(clientNr, contractNr, number, icc) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/provisioning/Mobile/%i/%i/number/%s/change-icc/%s"))(clientNr)(contractNr)(number)(icc)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const record = some({});
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_4 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(unit_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(unit_type, arg_4, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(obj_type), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(record));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        });
    }
}

export function BarringApi_loadStatus(clientNr, contractNr, number) {
    return singleton.Delay(() => {
        let matchValue, parseFn, arg_3;
        return singleton.Bind((matchValue = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/provisioning/Barring/%i/%i/number/%s"))(clientNr)(contractNr)(number))), (matchValue.tag === 1) ? singleton.Return(new FSharpResult$2(1, matchValue.fields[0])) : ((parseFn = ((arg_3 = defaultArg(new CaseStrategy(0), new CaseStrategy(0)), (arg_1_1) => {
            const str = arg_1_1;
            return equals(BarringStatusDTO1$reflection(), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(BarringStatusDTO1$reflection(), arg_3, Http_get_ExtraCoders().Value)), str);
        })), singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(BarringStatusDTO1$reflection(), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }))))), (_arg_1) => {
            let matchValue_3, parseFn_2, arg_8;
            return singleton.Bind((matchValue_3 = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/provisioning/Topup/%i/%i/number/%s/barring-sms-topup"))(clientNr)(contractNr)(number))), (matchValue_3.tag === 1) ? singleton.Return(new FSharpResult$2(1, matchValue_3.fields[0])) : ((parseFn_2 = ((arg_8 = defaultArg(new CaseStrategy(0), new CaseStrategy(0)), (arg_1_2) => {
                const str_1 = arg_1_2;
                return equals(option_type(bool_type), string_type) ? (new FSharpResult$2(0, str_1)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(option_type(bool_type), arg_8, Http_get_ExtraCoders().Value)), str_1);
            })), singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue_3.fields[0])))))), (_arg_2) => {
                let response_3;
                return singleton.Return((response_3 = _arg_2, (response_3.statusCode === 200) ? (equals(option_type(bool_type), string_type) ? (new FSharpResult$2(0, response_3.responseText)) : parseFn_2(response_3.responseText)) : (new FSharpResult$2(1, response_3.responseText))));
            }))))), (_arg_3) => {
                let matchValue_6, parseFn_4, arg_13;
                return singleton.Bind((matchValue_6 = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/provisioning/Topup/%i/%i/number/%s/barring-sms-topup-enabled"))(clientNr)(contractNr)(number))), (matchValue_6.tag === 1) ? singleton.Return(new FSharpResult$2(1, matchValue_6.fields[0])) : ((parseFn_4 = ((arg_13 = defaultArg(new CaseStrategy(0), new CaseStrategy(0)), (arg_1_3) => {
                    const str_2 = arg_1_3;
                    return equals(bool_type, string_type) ? (new FSharpResult$2(0, str_2)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(bool_type, arg_13, Http_get_ExtraCoders().Value)), str_2);
                })), singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue_6.fields[0])))))), (_arg_4) => {
                    let response_5;
                    return singleton.Return((response_5 = _arg_4, (response_5.statusCode === 200) ? (equals(bool_type, string_type) ? (new FSharpResult$2(0, response_5.responseText)) : parseFn_4(response_5.responseText)) : (new FSharpResult$2(1, response_5.responseText))));
                }))))), (_arg_5) => singleton.Return(Result_Bind((x1) => Result_Bind((x2) => {
                    let s1;
                    return Result_Map((s1 = x1, (s3) => (new BarringStatus(s1.InternationalOut, s1.Locked, s1.Outgoing, s1.Premium, s1.Roaming, x2, s3))), _arg_5);
                }, _arg_3), _arg_1)));
            });
        });
    });
}

export function BarringApi_saveStatus(clientNr, contractNr, number, barringStatus) {
    return singleton.Delay(() => {
        let body, matchValue, requestCaseStrategy_1, parseFn, arg_3, jsonStr;
        return singleton.Bind((body = (new BarringStatusDTO1(barringStatus.Locked, barringStatus.Outgoing, barringStatus.Roaming, barringStatus.Premium, barringStatus.InternationalOut)), (matchValue = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/provisioning/Barring/%i/%i/number/%s/set"))(clientNr)(contractNr)(number))), (matchValue.tag === 1) ? singleton.Return(new FSharpResult$2(1, matchValue.fields[0])) : ((requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0)), (parseFn = ((arg_3 = defaultArg(new CaseStrategy(0), new CaseStrategy(0)), (arg_1_1) => {
            const str = arg_1_1;
            return equals(unit_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(unit_type, arg_3, Http_get_ExtraCoders().Value)), str);
        })), (jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(BarringStatusDTO1$reflection()), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(body)), singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        }))))))), (_arg_1) => {
            let matchValue_4, requestCaseStrategy_1_1, parseFn_1, arg_8, jsonStr_1;
            return singleton.Bind((barringStatus.Topup != null) ? ((matchValue_4 = ValidatedUrlModule_create(new UrlKind(1, toText(printf("provisioning/Topup/%i/%i/number/%s/barring-sms-topup"))(clientNr)(contractNr)(number))), (matchValue_4.tag === 1) ? singleton.Return(new FSharpResult$2(1, matchValue_4.fields[0])) : ((requestCaseStrategy_1_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0)), (parseFn_1 = ((arg_8 = defaultArg(new CaseStrategy(0), new CaseStrategy(0)), (arg_1_2) => {
                const str_1 = arg_1_2;
                return equals(unit_type, string_type) ? (new FSharpResult$2(0, str_1)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(unit_type, arg_8, Http_get_ExtraCoders().Value)), str_1);
            })), (jsonStr_1 = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(option_type(option_type(bool_type))), requestCaseStrategy_1_1, Http_get_ExtraCoders().Value, false)(some(some(barringStatus.Topup)))), singleton.Delay(() => {
                let a_2;
                return singleton.Bind((a_2 = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr_1), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue_4.fields[0]))))))), singleton.Bind(a_2, Http_send)), (_arg_2) => {
                    const response_1 = _arg_2;
                    return (response_1.statusCode === 200) ? singleton.Return(parseFn_1(response_1.responseText)) : singleton.Return(new FSharpResult$2(1, response_1.responseText));
                });
            }))))))) : singleton.Return(new FSharpResult$2(0, void 0)), (_arg_3) => singleton.Return(Result_Bind(() => Result_Map(() => {
            }, _arg_3), _arg_1)));
        });
    });
}

export function GeneralApi_loadAllStatuses(clientNr, contractNr, number) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/provisioning/%i/%i/number/%s/false"))(clientNr)(contractNr)(number)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_3 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(NumberState$reflection(), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(NumberState$reflection(), arg_3, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(NumberState$reflection(), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

